import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output
} from '@angular/core';
import {
  BaseProperties,
  BorderStyle,
  TabItem,
  UIEvent
} from '@com-delta-idp/mnx-ui-kit';
import { CreditSummaryStyles } from './models/credit-summary.interfaces';
import {
  OfferBanner,
  OfferBannerConfig,
  OfferBannerStyles
} from './models/ui.interfaces';
import { GenericLabel } from '@com-delta-idp/mnx-utils';

@Component({
  selector: 'idp-fast-action-banner-page',
  templateUrl: './fast-action-banner-page.component.html',
  styleUrls: ['./fast-action-banner-page.component.scss']
})
export class FastActionBannerPageComponent
  implements
    OnChanges,
    BaseProperties<OfferBannerConfig, OfferBanner, OfferBannerStyles>
{
  @Input() config: OfferBannerConfig = {} as OfferBannerConfig;
  @Input() content: OfferBanner = {} as OfferBanner;
  @Input() styles: OfferBannerStyles = {} as OfferBannerStyles;
  @Input() title = '';

  @Output() offerAction = new EventEmitter<UIEvent>();
  @Output() openLink = new EventEmitter<string>();
  @Input() displaySecondaryHeader = false;
  desktop = true;
  creditSummaryStyles: CreditSummaryStyles = {} as CreditSummaryStyles;

  WHITE_COLOR = '#ffffff';
  private _creditSummaryBackgroundColor = '';

  changeTab(selectedLink: TabItem) {
    this.openLink.emit(selectedLink.url);
  }

  notifyAction(event: UIEvent) {
    this.offerAction.emit(event);
  }

  // todo: need to find a better way to avoid dependency on isPlatformBrowser
  ngOnChanges() {
    this._creditSummaryBackgroundColor =
      this.styles.creditSummary.backgroundColor;

    if (window.innerWidth < 1200) {
      this.styles = Object.assign({}, this.styles, {
        creditSummary: {
          ...this.styles.creditSummary,
          backgroundColor: this.WHITE_COLOR
        }
      });
      this.desktop = false;
    } else {
      this.desktop = true;
    }

    this.creditSummaryStyles = { ...this.styles.creditSummary };
    this.creditSummaryStyles.border = this.getBorderStyles('top');
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.creditSummaryStyles = { ...this.styles.creditSummary };

    if (event && (event.target as Window).innerWidth < 1200) {
      this.styles = Object.assign({}, this.styles, {
        creditSummary: {
          ...this.styles.creditSummary,
          backgroundColor: this.WHITE_COLOR
        }
      });
      this.desktop = false;
    } else {
      this.creditSummaryStyles.backgroundColor =
        this._creditSummaryBackgroundColor;
      this.desktop = true;
    }

    this.creditSummaryStyles.border = this.getBorderStyles('top');
  }

  /**
   * Get the right border styles per breakpoint
   *
   * NOTE: border-bottom and border-top are always setting
   * to avoid losing their value on window resize
   */

  getBorderStyles(side: string): BorderStyle {
    let border = '';

    if (this.styles?.offer?.containerStyles?.borderColor) {
      border = `2px solid ${this.styles.offer.containerStyles.borderColor}`;
    }

    let style: BorderStyle = {
      border,
      'border-bottom': border,
      'border-top': border
    };

    if (!this.desktop) {
      style = this.setBorders(border, side, style);
    }

    return style;
  }

  setBorders(border: string, side: string, style: BorderStyle): BorderStyle {
    if (side === 'top') {
      style['border-top'] = 'none';
    }

    if (side === 'bottom') {
      style['border-bottom'] = 'none';
      style = this.bordersBasedOnConfig(style, border);
    }
    return style;
  }

  bordersBasedOnConfig(style: BorderStyle, border: string): BorderStyle {
    if (this.config.congratulation || !this.config.showCreditSummary) {
      style['border-bottom'] = border;
    }
    return style;
  }

  setActionMessages(content: OfferBanner): GenericLabel {
    return {
      title: content.action?.message?.title || '',
      subtitle: content.action?.message?.subtitle || ''
    };
  }
}
